declare global {
  interface Window {
    __env__: TEnvironment;
  }
}

const environment = window.__env__;

export type TEnvironment = {
  BASE_URL: string;
  CDN_URL: string;
  ENV: string;
  FEATURES: string;
};

checkEnvVar('ENV', import.meta.env.VITE_ENV);
checkEnvVar('FEATURES', import.meta.env.VITE_FEATURES);
checkEnvVar('CDN_URL', import.meta.env.VITE_CDN_URL);


function checkEnvVar(key: keyof TEnvironment, processedValue?: string) {
  if (environment[key] === `$${key}`) {
    if (!processedValue) {
      throw Error(`Missing environment variable "${key}" in .env file`);
    }
    environment[key] = processedValue;
  }
}

const module = {
  ...environment,
  isProd: /prod/i.test(environment.ENV),
  isStaging: /staging/i.test(environment.ENV),
  isDev: !/prod/i.test(environment.ENV) && !/staging/i.test(environment.ENV),
};

export default module;
